<template>
  <div class=" bg-beige-academy-100 rounded-3xl shadow-lg w-11/12 lg:w-1/2 font-sans-serif
  mx-auto">
    <div v-show="title" class="uppercase text-sm lg:text-xl mt-6"> {{ title }} </div>
    <div class="flex flex-col bg-white m-0 md:m-16 my-12 md:my-16 rounded-none
    md:rounded-2xl shadow-lg h-auto lg:h-screen overflow-y-scroll">
      <button :disabled="!buttons" :class="buttons ?
      'hover:bg-orange-academy-300 hover:text-white transform hover:scale-105' : 'cursor-default'"
        v-for="m in media" :key="m.id" @click="$emit('selected',m)">
          <media-row :media="m" :editing="editing" :openable="!buttons"
          @delete="$emit('delete', m)" />
      </button>
    </div>
  </div>
</template>

<script>
import MediaRow from '@/components/teachers/MediaRow.vue';

export default {
  props: ['media', 'buttons', 'title', 'editing'],

  components: {
    MediaRow,
  },
};
</script>
